module.exports = __webpack_public_path__ + "static/media/paymentGateway.2b3b3330.png";